import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ContactUsMessagesService } from '../../services/contact-us-messages.service';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from '../../../../shared/Services/PagingService';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { ContactUsMessageDetailsComponent } from '../contact-us-message-details/contact-us-message-details.component';
import { ContactUsMessageReplyComponent } from '../contact-us-message-reply/contact-us-message-reply.component';

@Component({
  selector: 'get-contact-us-messages',
  templateUrl: './get-contact-us-messages.component.html',
  styleUrls: ['./get-contact-us-messages.component.scss']
})
export class GetContactUsMessagesComponent extends BaseComponent implements OnInit {
  form: FormGroup;
  exporting = false;
  constructor(
    public service: ContactUsMessagesService,
    route: Router,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private fb: FormBuilder,
    private paging: PagingService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  loadEntities() {
    console.log('Loading contact us messages...');
    if (this.isAuthorized) {
      this.service.get(this.pagingModel.query).subscribe(
        (res) => {
          console.log('Contact us messages data received:', res);
          this.initiResponse(res);
          this.finishLoading = true;
        },
        (error) => {
          console.error('Error loading contact us messages:', error);
          this.finishLoading = true;
        }
      );
    }
  }

  intitForm() {
    this.form = this.fb.group({
      email: [''],
      subject: [''],
    });
  }

  handleSearch() {
    let serchTermArr = [];

    if (this.form.value.email && this.form.value.email.trim()) {
      let email = this.form.value.email.trim();
      this.form.controls['email'].setValue(email);
      serchTermArr.push(`email:${email}`);
    }

    if (this.form.value.subject && this.form.value.subject.trim()) {
      let subject = this.form.value.subject.trim();
      this.form.controls['subject'].setValue(subject);
      serchTermArr.push(`subject:${subject}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }

  clearFilter() {
    this.form.controls['email'].setValue('');
    this.form.controls['subject'].setValue('');
    this.loadEntitiesWithFilter('');
  }
  reply(model) {
    this.diag.open(ContactUsMessageReplyComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }
  detail(model) {
    this.diag.open(ContactUsMessageDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  exportCsv() {
    const subject = this.form.value.subject ? this.form.value.subject.trim() : '';
    if (!subject) return;

    this.exporting = true;
    const query = { ...this.pagingModel.query, currentPage: 1, pageSize: 10000, searchTerm: `subject:${subject}` };

    this.service.get(query as any).subscribe(
      (res: any) => {
        const items = (res && res.result) || (res && res.data) || (res && res.responseObj) || (Array.isArray(res) ? res : []);
        if (!items.length) {
          this.toast.warning('لا توجد بيانات للتصدير', 'تنبيه');
          this.exporting = false;
          return;
        }

        const headers = ['الاسم', 'البريد الإلكتروني', 'رقم الهاتف', 'الموضوع', 'الرسالة', 'حالة الرد'];
        const rows = items.map((m: any) => {
          const messageContent = m.messsage || m.message || m.body || '';
          // Remove potential HTML tags, escape quotes, and replace newlines to prevent CSV breakages
          const cleanMessage = messageContent
            .replace(/<[^>]*>?/gm, '')
            .replace(/"/g, '""')
            .replace(/\r\n/g, ' - ')
            .replace(/\n/g, ' - ')
            .replace(/\r/g, ' - ');
            
          return [
            `"${(m.firstName || '') + ' ' + (m.lastName || '')}"`,
            `"${m.email || ''}"`,
            `"${m.phoneNumber || ''}"`,
            `"${m.subject || ''}"`,
            `"${cleanMessage}"`,
            `"${m.messageStatus === 1 ? 'تم الرد' : 'لم يتم الرد'}"`
          ];
        });

        const csvContent = '\uFEFF' + [headers.join(','), ...rows.map(r => r.join(','))].join('\r\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `contact-messages-${subject}-${new Date().toISOString().slice(0, 10)}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.exporting = false;
      },
      (error) => {
        console.error('Export failed:', error);
        this.toast.danger('فشل التصدير', 'خطأ');
        this.exporting = false;
      }
    );
  }

}
